// frontend/src/pages/PaymentFailedPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaTimesCircle, FaArrowLeft } from 'react-icons/fa';

function PaymentFailedPage() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center bg-gray-50 px-4 text-center">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
        <FaTimesCircle className="text-red-500 text-6xl mx-auto mb-6" />
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Payment Failed</h1>
        <p className="text-gray-600 mb-8">
          Unfortunately, your payment could not be processed. Please try again or contact support if the issue persists.
        </p>
        
        <div className="space-y-3">
          <Link 
            to="/account" 
            className="block w-full bg-primary hover:bg-primary-dark text-white font-bold py-3 px-4 rounded-lg transition duration-300 flex items-center justify-center gap-2"
          >
            <FaArrowLeft /> Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PaymentFailedPage;